import * as React from "react";
import { db } from "../firebaseSetup";
import { Form, Input, Button } from "antd";
import { useForm } from "antd/lib/form/Form";

export const AddPlayer: React.FC = () => {
  const [form] = useForm();

  const onFinish = async (values: Backend.Player) => {
    if (!values.name) {
      return;
    }

    await db.collection("players").add(values);
    form.resetFields();
  };

  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <Form.Item required name="name" label="Namn">
          <Input />
        </Form.Item>
        <Button size="large" type="primary" htmlType="submit">SPARA SPELARE</Button>
      </Form>
    </div>
  );
};
